import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../utils/axios";
import { ADMIN } from "../config/api";
import toast from "react-hot-toast";


function User() {
    const [User, setUser] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate(); // ✅ use navigate instead of window.location
    const token = localStorage.getItem("token");
    

    const handleDelete = async (id) => {
  if (!window.confirm("Are you sure you want to delete this User?")) return;

  try {
    const { data } = await apiClient.delete(ADMIN.DELETE_USER(id));
    if (!data.success) throw new Error(data.message || "Delete failed");

    toast.success("User deleted successfully");
    setUser(User.filter((c) => c._id !== id));
  } catch (err) {
    toast.error(err.response?.data?.message || err.message || "Failed to delete user");
  }
};

const handleEdit = (UserData) => {
    // Option 1: Navigate with query param
    navigate(`/addUser?id=${UserData._id}`);

    // Option 2: open a modal pre-filled with paymentData
  };

    useEffect(() => {
      const fetchuser = async () => {
        try {
          const { data } = await apiClient.get(ADMIN.GET_USER);
          if (data.success) {
            setUser(data.items);
          }
        } catch (err) {
          console.error("Error fetching user:", err);
          toast.error(err.response?.data?.message || err.message || "Failed to fetch users");
        } finally {
          setLoading(false);
        }
      };
  
      fetchuser();
    }, []);
  return (
    <>
      <div className="content-wrapper">
        <div className="page-header">
          <h3 className="page-title"> User Table </h3>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><a href="">Dashboard</a></li>
              <li className="breadcrumb-item active" aria-current="page">User Table</li>
            </ol>
            <div>
          </div>
          </nav>
        </div>
        <div className="row">
          <div className="col-lg-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-10">
                    <h4 className="card-title">User Data</h4>
                    <p className="card-description"></p>
                  </div>
                  <div className="col-2">
                    <a href="./adduser">
                      <button className="btn-primary">Add User</button>
                    </a>
                  </div>
                </div>
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th> Sr.No </th>
                        <th> Name </th>
                        <th> Email </th>
                        <th> Password </th>
                        <th> Role </th>
                        <th> Actions </th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="6" className="text-center">Loading...</td>
                        </tr>
                      ) : User.length === 0 ? (
                        <tr>
                          <td colSpan="6" className="text-center">No tables found</td>
                        </tr>
                      ) : (
                        User.map((t, index) => (
                          <tr key={t._id}>
                            <td>{index + 1}</td>
                            <td>{t.name}</td>
                            <td>{t.email}</td>
                            <td>{t.password}</td>
                            <td>{t.role}</td>

                            <td>
                              
                              <button
                                className="btn btn-primary me-2"
                                onClick={() => handleEdit(t)}
                              >
                                Edit
                              </button>
                                <button
                                className="btn btn-danger"
                                onClick={() => handleDelete(t._id)}
                              >Delete</button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default User
